import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BusinessAccountsService } from '../business-accounts.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-efficient-payment',
  templateUrl: './efficient-payment.component.html',
  imports: [CommonModule],
})
export class EfficientPaymentComponent implements OnInit {
  efficientPanelData:any;

  constructor(private businessAccountsService: BusinessAccountsService) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    this.businessAccountsService.efficient$.subscribe(data => {
      if (data != null) {
        this.efficientPanelData = data;
      }
    });
  }

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    nav: true,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
}
